import { chain, DispatchBeginRemoveCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";

declare global {
    interface Window {
        dataLayer: Record<string, any>[];
    }
}

type HandlerProps = Parameters<typeof DispatchBeginRemoveCartLine>[0];
const GoogleAnalytics = (props: HandlerProps) => {
    window.dataLayer = window.dataLayer || [];
    const state = props.getState();
    if (!state.data.carts.currentId)
        return;
    
    const cart = state.data.carts.byId[state.data.carts.currentId]
    const cartLine = cart.cartLines?.find(l => l.id == props.parameter.cartLineId);
    
    window.dataLayer.push({
        "event": "remove_from_cart",
        "cart_id": cart.id,
        "cartline_id": props.parameter.cartLineId,
        "quantity": cartLine?.qtyOrdered,
        "product": {
            "product_number": cartLine?.erpNumber,
            "name": cartLine?.productName,
            "currency": state.context.session.currency?.currencyCode,
            "price": cartLine?.pricing?.unitListPrice,
        },
    })
}

addToEndOfChain(chain, GoogleAnalytics)